/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 25.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import _ from "underscore";
import "./Select.css";

class Select extends React.Component {
    static propTypes = {
        /**
         * ID
         */
        id: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
        /**
         * Name
         */
        name: PropTypes.string.isRequired,
        /**
         * Selected value
         */
        value: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
        /**
         * Options array. Each option should be either
         * two-item array of [value, label] or object {value: value, label: label, disabled: isDisabled}
         */
        options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.oneOfType([PropTypes.string,PropTypes.number])
        }),PropTypes.array])).isRequired,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        simple: PropTypes.bool,
        className: PropTypes.string,
        /**
         * onChange(name, value)
         */
        onChange: PropTypes.func
    };

    static defaultProps = {
        disabled: false,
        required: false,
        simple: false
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
        this.onChange = this.onChange.bind(this);
        this.onSimpleChange = this.onSimpleChange.bind(this);
    }

    getOptions() {
        if (this.props.options == null || this.props.options.length === 0) return this.props.options;
        if (_.isArray(this.props.options[0])) {
            return _.map(this.props.options, function (val) {
                return {
                    value: val[0],
                    label: (val.length === 1 ? val[0] : val[1])
                };
            });
        }
        return this.props.options;
    }

    onChange(value) {
        let v = (value == null ? null : value.value);
        if (_.isNumber(this.props.value) && !_.isNumber(v)) v = Number(v);
        if (this.props.onChange) this.props.onChange(this.props.name, v);
        else this.setState({value: v});
    }

    onSimpleChange(e) {
        e.preventDefault();
        this.onChange({value: e.target.value});
    }

    getSingleValue(value, emptyValue, options) {
        if (!value) return emptyValue;

        if (options) {
            // Find correct option:
            let item = _.find(options, {value: value});
            if (item) return item;
        }
        // No option found, crate option for selected value
        return {
            value: value,
            label: value
        }
    }

    renderSimpleSelect() {
        let value = (this.props.onChange ? this.props.value : this.state.value);
        let i = 1;
        return (
            <select
                id={this.props.id}
                className={this.props.className}
                name={this.props.name}
                value={value}
                required={this.props.required}
                disabled={this.props.disabled}
                aria-describedby={this.props.id ? this.props.id + "-help" : null}
                onChange={this.onSimpleChange}>
                {_.map(this.getOptions(), function (item) {
                    return (
                        <option key={i++} value={item.value}>{item.label}</option>
                    );
                })}
            </select>
        );
    }

    render() {
        if (this.props.simple) return this.renderSimpleSelect();
        const emptyValue = null;
        let value = (this.props.onChange ? this.props.value : this.state.value);
        let options = this.getOptions();
        return (
            <ReactSelect
                id={this.props.id}
                className={this.props.className}
                name={this.props.name}
                value={this.getSingleValue(value, emptyValue, options)}
                options={options}
                placeholder={this.props.placeholder}
                isDisabled={this.props.disabled}
                isClearable={true}
                aria-describedby={this.props.id ? this.props.id + "-help" : null}
                onChange={this.onChange}
                getOptionLabel={(o) => o.label}
                getOptionValue={(o) => o.value}
                styles={{menu: (base) => ({
                        ...base,
                        zIndex: "5 !important"
                    })}}
            />
        );
    }
}

export default Select;
